// extracted by mini-css-extract-plugin
export var aircallIframe = "_cw-3";
export var fabContainer = "_cw-5";
export var fabRinging = "_cw-6";
export var loadingOverlay = "_cw-4";
export var pulse = "_cw-7";
export var widgetContent = "_cw-2";
export var widgetPanel = "_cw-0";
export var widgetPanelExpanded = "_cw-1";